import { Col, Form, Input, Row, Spin } from "antd";
import { useForm } from "antd/es/form/Form";
import {
  LightBlueContainer,
  WhiteContainer,
} from "../../styled/Container.styled";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import {
  useGetTransactionByIdQuery,
} from "../../../feature/Transactions/transactionApiSlice";
import { DownloadOutlined } from "@ant-design/icons";
import { PrimaryButton } from "../../styled/Button.styled";

const ViewTransction = () => {
  const navigate = useNavigate();
  const [form] = useForm();
  const location: any = useLocation();
  const routerLocation = useLocation();

  const { data, isLoading } = useGetTransactionByIdQuery(
    location.state.transaction.tripId
  );

  const onClose = () => {
    const urlParams = new URLSearchParams(routerLocation.search);
    const page = urlParams.get("page") || "1";

    navigate(`/transactions?page=${page}`);
  };

  useEffect(() => {
    form.setFieldsValue({
      transactionId: data?.data.paymentId,
      driverName: data?.data.driverName,
      gst: data?.data.gst,
      dateOfTransaction: data?.data.dateOfTransaction
        ? dayjs(data?.data.dateOfTransaction).format("MM/DD/YYYY")
        : "",
      vehicleNumber: data?.data.vehicleNumber,
      actualTripAmount: data?.data.actualTripAmount ?? data?.data.transactionAmount,
      amountPaidByRider: data?.data.amountPaidByRider ?? data?.data.transactionAmount,
      fromAddress: data?.data.fromAddress,
      toAddress:
        data?.data.toAddress || data?.data.stop1 || "",
      couponApplied: data?.data.couponCode
        ? `${data.data.couponName} (${data.data.couponCode})`
        : "No coupon applied",
      couponValue: data?.data.couponCode ? data.data.couponValue : "-",
      paymentMode: data?.data.paymentMode,
    });
  }, [form, data]);

  return (
    <>
      <div style={{ position: "relative" }}>
        <div>
          <Row
            justify="end"
            gutter={20}
            className="button-bottom-margin"
          >
            <Col>
              <PrimaryButton onClick={onClose}>
                Back
              </PrimaryButton>
            </Col>
          </Row>

          <LightBlueContainer>
            <Col
              style={{
                padding: "0.5% 0",
                marginLeft: "auto",
                fontWeight: 500,
                fontSize: "1.2rem",
              }}
            >
              <a
                target="_blank"
                rel="noreferrer"
                href={data?.data.invoice}
              >
                <DownloadOutlined
                  style={{ fontSize: "1.75rem" }}
                />{" "}
                Download Transaction Receipt
              </a>
            </Col>

            <WhiteContainer className="transaction-table">
              {!isLoading ? (
                <Form
                  form={form}
                  name="dynamic_rule"
                  layout="vertical"
                >
                  <Row gutter={10}>
                    <Col md={12}>
                      <Form.Item
                        label="Payment ID"
                        name="transactionId"
                      >
                        <Input.Password readOnly className="readonly-password" />
                      </Form.Item>
                      <Form.Item
                        label="Transaction Date"
                        name="dateOfTransaction"
                      >
                        <Input disabled={true} />
                      </Form.Item>
                      <Form.Item
                        label="Payment Mode"
                        name="paymentMode"
                      >
                        <Input disabled={true} />
                      </Form.Item>
                      <Form.Item
                        label="Actual Trip Amount (incl. GST)"
                        name="actualTripAmount"
                      >
                        <Input prefix="₹" disabled={true} />
                      </Form.Item>
                      <Form.Item
                        label="Amount Paid by Rider"
                        name="amountPaidByRider"
                      >
                        <Input prefix="₹" disabled={true} />
                      </Form.Item>
                      <Form.Item
                        label="GST Charged"
                        name="gst"
                      >
                        <Input prefix="₹" disabled={true} />
                      </Form.Item>
                    </Col>

                    <Col md={12}>
                      <Form.Item
                        label="Driver"
                        name="driverName"
                      >
                        <Input disabled={true} />
                      </Form.Item>
                      <Form.Item
                        label="Vehicle Number"
                        name="vehicleNumber"
                      >
                        <Input.Password readOnly className="readonly-password" />
                      </Form.Item>
                      <Form.Item
                        label="From Address"
                        name="fromAddress"
                      >
                        <TextArea disabled={true} />
                      </Form.Item>
                      <Form.Item
                        label="To Address"
                        name="toAddress"
                      >
                        <TextArea disabled={true} />
                      </Form.Item>
                      <Form.Item
                        label="Coupon Applied"
                        name="couponApplied"
                      >
                        <Input disabled={true} />
                      </Form.Item>
                      <Form.Item
                        label="Coupon Amount"
                        name="couponValue"
                      >
                        <Input prefix="₹" disabled={true} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <Spin size="large" />
              )}
            </WhiteContainer>
          </LightBlueContainer>
        </div>
      </div>
    </>
  );
};

export default ViewTransction;